<template>
    <pre
            ref="code" class="syntax-highlight grey lighten-4 pa-4"
            :class="lang"
            style="width: 100%; height: inherit ">
    </pre>
</template>

<script>
    import hljs from 'highlight.js/lib/highlight';

    export default {
        name: "CodeView",
        props: ['code', 'lang'],
        watch: {
            code() {
                // code update won't trigger dom update or the "updated" hook
                this.updateAndHighlight();
            }
        },
        methods: {
            updateAndHighlight() {
                this.$refs.code.innerText = this.code;
                hljs.highlightBlock(this.$refs.code);
            }
        },
        mounted() {
            // Need to trigger at mounted as watch doesn't this to work...
            this.updateAndHighlight();
        },
        updated() {
            // Wit for the dom to be updated to execute dom manipulation (need "lang" to be updated)
            this.updateAndHighlight();
        }
    }
</script>